import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

import Text from '@g4/boneyard/lib/Text';
import { TrackClick } from '@g4/trackster';

import { trackEvent } from '../Analytics';

const Link = styled.a`
  position: relative;
  display: block;
  font-size: 0.75rem;
  color: ${props => props.theme.colors.hob.footer.link};

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  ${props => props.theme.query.sm} {
    display: inline-block;
    padding-right: ${props => props.theme.spacing(4)};

    /* Bullet point divider between items on smaller viewports */
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 4px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      /* Deduct half the width of the bullet point */
      right: calc(${props => props.theme.spacing(2)} - 2px);
      border-radius: 50%;
      background-color: ${props => props.theme.colors.hob.footer.divider};
    }
  }

  ${props => props.theme.query.lg} {
    display: block;
    padding-right: 0;

    &::after {
      display: none;
    }
  }
`;

const OverStyledText = styled(Text)`
  line-height: 2.57;
  color: #263238;
  text-align: center;
  ${props => props.theme.query.sm} {
    text-align: left;
  }
`;

const FooterLink = ({ item: { id, title, link }, mediaMenu }) => {
  return mediaMenu ? (
    <TrackClick
      action={
        'HO Allegiant Air - Cheap Flights, Air+Hotel Packages, Discounted Car Rentals'
      }
      label={link.path || link.url}
      category={'Exit Links'}
      key={id}
    >
      <Link
        target={link.target}
        href={link.path || link.url}
        onClick={() => trackEvent('Site Click Tracking', 'HO Footer', title)}
      >
        <OverStyledText size={14} children={title} />
      </Link>
    </TrackClick>
  ) : (
    <TrackClick action={'HO Footer'} label={title} key={id}>
      <Link target={link.target} href={link.path || link.url}>
        <OverStyledText size={14} children={title} />
      </Link>
    </TrackClick>
  );
};

FooterLink.propTypes = {
  item: PropTypes.object.isRequired,
  mediaMenu: PropTypes.bool,
};

export default withTheme(FooterLink);
